<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      breadcrumb: {
        name: new Promise(resolve => {
          this.$sdk
            .pickup
            .read(this.$route.params.pickupId)
            .then((response) => {
              resolve(response.booking_reference)
            })
        }),
        route: { name: 'customerservice-pickups-pickup', params: { pickupId: this.$route.params.pickupId } }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'file-invoice'],
          route: { name: 'customerservice-pickups-pickup-details', params: { pickupId: this.$route.params.pickupId } },
          name: 'Details'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'sticky-note'],
          route: { name: 'customerservice-pickups-pickup-notes', params: { pickupId: this.$route.params.pickupId } },
          name: 'Notes'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'history'],
          route: { name: 'customerservice-pickups-pickup-history', params: { pickupId: this.$route.params.pickupId } },
          name: 'History'
        }
      ]
    }
  }
}
</script>
